module.exports = __webpack_public_path__ + "img/walletconnect.92044555.svg";